import { Injectable } from '@angular/core';
import {
  ICanal,
  ICreateCanal,
  ICreateRepresa,
  IDispositivo,
  IQueryParam,
  IRepresa,
  IUpdateCanal,
  IUpdateRepresa,
} from 'modelos/src';
import { Observable } from 'rxjs';
import { HelperService } from 'src/app/auxiliares/helper.service';
import { apiBase } from '../../../../environments/environment';
import { HttpService } from '../../../auxiliares/http.service';
import { IConfigs } from '../../offline/configuracion-canal/bluetooth.service';

const api = apiBase;

@Injectable({
  providedIn: 'root',
})
export class CanalesService {
  constructor(private http: HttpService) {}
  // Canales
  public getCanal(id: string): Observable<ICanal> {
    return this.http.get(`${api}/canales/${id}`);
  }
  public getCanales(queryParams?: IQueryParam): Observable<{
    data: ICanal[];
    total: number;
  }> {
    const params = HelperService.getQueryParams(queryParams);
    return this.http.get(`${api}/canales`, { params });
  }
  public createCanal(data: ICreateCanal): Observable<ICanal> {
    return this.http.post(`${api}/canales`, data);
  }
  public updateCanal(id: string, data: IUpdateCanal): Observable<ICanal> {
    return this.http.put(`${api}/canales/${id}`, data);
  }
  public deleteCanal(id: string): Observable<ICanal> {
    return this.http.delete(`${api}/canales/${id}`);
  }
  // Canales
  public getRepresa(id: string): Observable<IRepresa> {
    return this.http.get(`${api}/represas/${id}`);
  }
  public getRepresaes(queryParams?: IQueryParam): Observable<{
    data: IRepresa[];
    total: number;
  }> {
    const params = HelperService.getQueryParams(queryParams);
    return this.http.get(`${api}/represas`, { params });
  }
  public createRepresa(data: ICreateRepresa): Observable<IRepresa> {
    return this.http.post(`${api}/represas`, data);
  }
  public updateRepresa(id: string, data: IUpdateRepresa): Observable<IRepresa> {
    return this.http.put(`${api}/represas/${id}`, data);
  }
  public deleteRepresa(id: string): Observable<IRepresa> {
    return this.http.delete(`${api}/represas/${id}`);
  }

  // Config dispositivo

  public config(deveui: string, config: IConfigs) {
    return this.http.post(`${api}/comandos/canal/config`, {
      deveui,
      config,
    });
  }

  // Helper

  private fechaAyer() {
    const fecha = new Date();
    fecha.setDate(fecha.getDate() - 1);
    return fecha;
  }

  public estadoRepresa(dato: IRepresa) {
    if (dato.dispositivoCanal) {
      return this.estadoDispositivo(dato.dispositivoCanal);
    }

    const ayer = this.fechaAyer();
    const ultimoReporte = dato.ultimoReporte?.fecha
      ? new Date(dato.ultimoReporte.fecha)
      : null;
    const ultimaAlerta = dato.ultimaAlerta?.fecha
      ? new Date(dato.ultimaAlerta.fecha)
      : null;
    if (ultimaAlerta) {
      if (!ultimoReporte || ultimaAlerta > ultimoReporte) {
        return 'Alerta';
      }
    }
    if (!ultimoReporte || ayer > ultimoReporte) {
      return 'Sin reportar';
    }
    return 'Ok';
  }

  public estadoDispositivo(dato: IDispositivo) {
    const ayer = this.fechaAyer();
    const ultimoReporte = dato.ultimoReporte?.fecha
      ? new Date(dato.ultimoReporte.fecha)
      : null;
    const ultimaAlerta = dato.ultimaAlerta?.fecha
      ? new Date(dato.ultimaAlerta.fecha)
      : null;
    if (ultimaAlerta) {
      if (!ultimoReporte || ultimaAlerta > ultimoReporte) {
        return 'Alerta';
      }
    }
    if (!ultimoReporte || ayer > ultimoReporte) {
      return 'Sin reportar';
    }
    return 'Ok';
  }

  public estadoDispositivo2(dato: IDispositivo) {
    const ayer = this.fechaAyer();
    const ultimoReporte = dato.ultimoReporte?.fecha
      ? new Date(dato.ultimoReporte.fecha)
      : null;
    const ultimaAlerta = dato.ultimaAlerta?.fecha
      ? new Date(dato.ultimaAlerta.fecha)
      : null;
    if (ultimaAlerta) {
      if (!ultimoReporte || ultimaAlerta > ultimoReporte) {
        return HelperService.alerta;
      }
    }
    if (!ultimoReporte || ayer > ultimoReporte) {
      return HelperService.alerta;
    }
    if (dato.ultimoReporte?.reporte?.distancia < 500) {
      return HelperService.okWarning;
    }
    return HelperService.ok;
  }

  public calcularAltura(
    cota: number,
    distancia: number,
    unidad = 'mm.',
  ): number {
    let res;
    if (cota) {
      res = cota - distancia;
    } else {
      res = distancia;
    }

    if (unidad === 'm.') {
      res = +(res / 1000).toFixed(2);
    }
    if (unidad === 'cm.') {
      res = +(res / 10).toFixed(1);
    }
    return res;
  }

  public calcularAlturaCanal(distancia: number, canal?: ICanal): number {
    const igm = canal?.igm || canal?.dispositivoCanal?.config?.igm || 0;
    if (igm) {
      return igm - distancia;
    } else {
      return distancia;
    }
  }

  public mmToCm(distancia: number): number {
    return +(distancia / 10).toFixed(1);
  }

  public async exportarReportes(
    queryParams?: IQueryParam,
    filename = 'reportes.xlsx',
  ): Promise<void> {
    const params = HelperService.getQueryParams(queryParams);
    await this.http.getFile(`${api}/reportes/exportar/canal`, filename, params);
  }

  public estadoCanal(dato: ICanal) {
    const limite = this.fechaHaceXHoras(6);
    const ultimaComunicacion = dato.ultimaComunicacion
      ? new Date(dato.ultimaComunicacion)
      : null;

    if (!ultimaComunicacion || limite > ultimaComunicacion) {
      return 'Sin reportar';
    }

    return dato.ultimoEstado;
  }

  private fechaHaceXHoras(horas: number) {
    const fecha = new Date();
    fecha.setHours(fecha.getHours() - horas);
    return fecha;
  }
}
